// Route-shape predicates for the product-list page types. Kept here (instead of
// inline in pageTypeMixin) so the Options-API mixin, the `<script setup>`
// composable and any plain helper all test the same patterns.
//
// Every predicate takes the whole route (anything with `path` and `fullPath`) and
// picks the field it needs itself: search matches on `fullPath` because it keys off
// the query string, the rest match on `path`. Passing the route as a unit removes
// the easy mistake of handing `route.path` to a predicate that wanted `route.fullPath`.

export interface RouteLike {
  path: string;
  fullPath: string;
}

export function isSearchPath ({ fullPath }: RouteLike): boolean {
  return /.*?\/search\?(.*)/i.test(fullPath);
}

export function isBoutiquePath ({ path }: RouteLike): boolean {
  return /.*?\.b-([0-9]+)/i.test(path);
}

export function isShortListPath ({ path }: RouteLike): boolean {
  return /.*?\/list/i.test(path);
}

export function isLoyaltyOfferPath ({ path }: RouteLike): boolean {
  return /.*?\/(loyalty-offers|bizalomkartyas-ajanlatok)/i.test(path);
}

// The lists that receive the hierarchical, multi-select category filter. Category
// pages are deliberately absent: they keep the single-level `subcategory` filter.
export function isCategorySelectionFilterPath (route: RouteLike): boolean {
  return (isBoutiquePath(route)
    || isShortListPath(route)
    || isLoyaltyOfferPath(route)
    || isSearchPath(route)
  );
}
